type ModalHeaderProps = {
  title: string;
};

const ModalHeader = ({ title }: ModalHeaderProps) => {
  return (
    <div className="mb-16">
      <div className="absolute w-full bg-silver border border-b-blue -ml-6 py-5 px-7 top-0">
        <span className="text-blue tracking-ultraWidest text-base font-medium">
          {title}
        </span>
      </div>
    </div>
  );
};

export default ModalHeader;
